(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quantity-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quantity-selector')) {
    customElements.define('quantity-selector', class QuantitySelector extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        this.decreaseButton = this.querySelector('[data-quantity-decrease]');
        this.increaseButton = this.querySelector('[data-quantity-increase]');
        this.decreaseButton.addEventListener('click', () => this.change(-1, true));
        this.increaseButton.addEventListener('click', () => this.change(1, true));
        this.input.addEventListener('change', () => this.normalize(true));
        this.updateButtons();
      }

      change(direction, updateCart) {
        const step = Number(this.input.step) || 1;
        this.setValue(Number(this.input.value) + (direction * step), updateCart);
      }

      normalize(updateCart) {
        this.setValue(Number(this.input.value), updateCart);
      }

      setValue(value, updateCart) {
        const minimum = this.input.min === '' ? 0 : Number(this.input.min);
        const maximum = this.input.max === '' ? Number.POSITIVE_INFINITY : Number(this.input.max);
        const normalized = Math.min(maximum, Math.max(minimum, Number.isFinite(value) ? value : minimum));
        const changed = Number(this.input.value) !== normalized;
        this.input.value = normalized;
        this.updateButtons();

        if (changed) {
          this.input.dispatchEvent(new Event('input', { bubbles: true }));
        }

        if (changed && updateCart && this.dataset.cartItemKey) {
          this.scheduleCartUpdate();
        }
      }

      scheduleCartUpdate() {
        window.clearTimeout(this.updateTimer);
        this.updateTimer = window.setTimeout(() => this.updateCart(), 250);
      }

      async updateCart() {
        this.setAttribute('aria-busy', 'true');
        this.decreaseButton.disabled = true;
        this.increaseButton.disabled = true;

        try {
          const response = await fetch(this.dataset.cartUpdateUrl, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              updates: {
                [this.dataset.cartItemKey]: Number(this.input.value)
              }
            })
          });

          if (!response.ok) throw new Error('Cart update failed');
          window.location.reload();
        } catch (error) {
          this.removeAttribute('aria-busy');
          this.updateButtons();
          this.closest('form')?.requestSubmit();
        }
      }

      updateButtons() {
        const value = Number(this.input.value);
        const minimum = this.input.min === '' ? 0 : Number(this.input.min);
        const maximum = this.input.max === '' ? Number.POSITIVE_INFINITY : Number(this.input.max);
        this.decreaseButton.disabled = value <= minimum;
        this.increaseButton.disabled = value >= maximum;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
